/* eslint-disable react/prop-types */
import React from "react"; // React Stuff
import axios from "axios";
import { Col, Row, Button, Table } from "react-bootstrap";
import { Link } from "react-router-dom";

const ClassRegisterTab = (props) => {
  const registers = props.data.Registers.sort(function (a, b) {
    return new Date(b.createdAt) - new Date(a.createdAt);
  })
  //generate a new register
  const registerGenerate = async (e) => {
    e.preventDefault();
    const classid = props.data._id;
    const registerGenerateRequest = await axios.post(
      `/api/admin/registers/create_register/${classid}`,
      {
        LessonType: props.data.LessonType,
        VenueName: props.data.VenueName,
        StartTime: props.data.StartTime,
        Day: props.data.Day,
      },
      {
        withCredentials: true,
      }
    );
    if (registerGenerateRequest.status === 200) {
      props.setSubmitClicked(false);
      props.setSuccessMessage("Register was successfully generated.");
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };
  return (
    <Row className='mt-5 mb-3 text-center'>
      <Col sm='12' className='border shadow p-3'>
        <h3 className='mt-4'>Registers</h3>
        <Button
          variant='primary'
          className='mb-3'
          as={Link}
          to={`/admin/registers/${props.data.Current_Register}`}
        >
          Current Register
        </Button>
        <p>
          This is a list of your last six registers. Registers are automatically generated first day
          of the month for subscription model classes. Active, Paused and Past Due subscriptions are
          automatically added to new registers.
        </p>

        <Table striped bordered hover responsive className='text-center'>
          <thead>
            <tr>
              <th>Register Date</th>
              <th>View/Manage</th>
            </tr>
          </thead>
          <tbody>
            {registers.map((Register) => (
              <tr key={Register._id}>
                <td className='align-self-center align-middle'>{Register.Register_Month}</td>
                <td className='align-self-center align-middle'>
                  <Button
                    variant='info'
                    size='sm'
                    type='link'
                    as={Link}
                    to={`/admin/registers/${Register._id}`}
                  >
                    Manage
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Row>
          <Col className='border'>
            <p>In some instances, you may want to generate a new register.</p>
            <Button
              variant='danger'
              className='mb-3'
              type='submit'
              disabled={props.submitClicked}
              onClick={(e) => registerGenerate(e)}
            >
              Generate Register
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ClassRegisterTab;
